import { Block, Text } from '@snowflake/core-ui';
import { CortexLogo } from './CortexLogo';
import * as React from 'react';
import { Footer } from './Footer';
import { InternalHeaders } from '../utils/InternalHeaders';
import { InfoList } from './MarketingText/InfoList';
import { isCortexWaitlistEnabled } from '../utils/configurations';
import { CortexInstallBlock } from './MarketingText/CortexInstallBlock';
import { BaseCardProps } from './Cards/shared/shared';
import { CortexCodeWaitListCardWrapper } from './Cards/forms/SignupCardV2/CortexCodeWaitListCardWrapper';
import { CortexFinePrint } from './MarketingText/CortexFinePrint';

interface CortexSignupContainerProps extends BaseCardProps {
  pageNotFound?: boolean;
  signupCard: React.ReactNode;
}

export const CortexSignupContainer = (props: CortexSignupContainerProps) => {
  const { signupCard, recaptchaRef, pageNotFound, signupParams, marketingParams, formId } = props;

  const renderLeftText = () => {
    return (
      <Block
        className="trial-left-container"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Block>
          <Text
            className="trial-title"
            allCaps={true}
            fontSize={50}
            lineHeight="57px"
            weight="bold"
            marginBottom={24}
          >
            <>
              <Text style={{ color: '#249EDC' }}>Build Faster with </Text>
              <Text style={{ color: '#000' }}>Cortex Code CLI</Text>
            </>
          </Text>
        </Block>
        <Block display="flex" alignItems="center" marginBottom={24}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            style={{ marginRight: '8px' }}
          >
            <path
              d="M8 0C9.34521 4.74504 11.2107 6.64414 16 8L15.5596 8.12891C11.2387 9.43397 9.42175 11.2796 8.12793 15.5635L8 16C6.65479 11.255 4.78932 9.35586 0 8C4.78932 6.64414 6.65479 4.74504 8 0Z"
              fill="#666666"
            />
          </svg>
          <Text style={{ color: '#666666', fontSize: '20px', lineHeight: '30px', fontWeight: 400 }}>
            Your AI coding assistant for data work
          </Text>
        </Block>
        <InfoList />
        {!isCortexWaitlistEnabled(signupParams) && (
          <>
            <Block marginTop="-12px">
              <Text
                weight="semi-bold"
                style={{ color: '#249EDC', fontSize: '20px', lineHeight: '30px' }}
                marginBottom="28px"
              >
                Start your introductory trial with $40 in free credits*
              </Text>
              <CortexInstallBlock />
            </Block>
            <CortexFinePrint />
          </>
        )}
      </Block>
    );
  };

  const getCardToRender = () => {
    if (isCortexWaitlistEnabled(signupParams)) {
      return (
        <CortexCodeWaitListCardWrapper
          signupParams={signupParams}
          marketingParams={marketingParams}
          formId={formId}
          recaptchaRef={recaptchaRef}
        />
      );
    }
    return signupCard;
  };

  return (
    <Block className="trial-page-container">
      <InternalHeaders />
      <Block className={'trial-responsive-flex-container cortex-background'} position="relative">
        <CortexLogo />
        {renderLeftText()}
        <Block
          className="trial-right-container"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          maxWidth="520px"
        >
          {getCardToRender()}
        </Block>
      </Block>
      <Footer recaptchaRef={recaptchaRef} pageNotFound={pageNotFound} />
    </Block>
  );
};
